import api from '@/api'
import errors from '@/api/errors'
import store from '@/store'

const baseUrlReg = process.env.REVIEW_API_BASE_URL_REG

const createParams = (args) => {
  const p = {}
  // required
  p.accessToken = store.getters['commons/cookies'].mchat
  p.sessionID = store.getters['commons/cookies'].encsid
  p.review_id = args.reviewId
  p.type = args.type
  p.description = args.description
  p.application = 2
  p.country = process.env.COUNTRY
  // non-required
  if (args.commentId) {
    p.comment_id = args.commentId
    p.entry_flag = '1' // コメント
  } else {
    p.entry_flag = '0' // レビュー
  }
  return p
}

const onReceived = (respBody) => {
  if (respBody.resultCode !== 0) {
    console.error(`API error code ${respBody.resultCode}`)
    if (respBody.resultCode === 611) { // アクセストークンエラー
      throw new errors.AuthenticationError()
    }
    if (respBody.resultCode === 105) { // バリデーションエラー
      throw new errors.InputValidationError(respBody.errorMessage)
    }
    throw new Error('問題が発生したためその後の処理を継続することができませんでした。時間を置いて再度利用をお願いします。')
  }
  return Promise.resolve(respBody.data)
}

export default {
  // レビュー報告登録
  reportReview: (args) => {
    const params = createParams(args)
    return api.post(`${baseUrlReg}/registReviewReport`, params).then(onReceived)
  }
}



// WEBPACK FOOTER //
// ./src/api/reports.js